export enum PostMessageIncomingAction {
  CAPINTEL_READY = 'capintel.ready',
  CAPINTEL_GET_BOOK_OF_BUSINESS = 'factset.bookOfBusiness',
  FACTSET_CONTEXT_CHANGED = 'factset.contextChanged',
  CAPINTEL_GET_PORTFOLIOS = 'factset.portfolios',
  FACTSET_ACCOUNT_LOOKUP_PORTFOLIOS = 'factset.accountLookupPortfolios',
}

export enum PostMessageOutgoingAction {
  FACTSET_READY = 'factset.ready',
  FACTSET_GET_BOOK_OF_BUSINESS = 'factset.getBookOfBusiness',
  FACTSET_GET_PORTFOLIOS = 'factset.getPortfolios',
  FACTSET_OPEN_ACCOUNT_LOOKUP = 'factset.openAccountLookup',
}
